export default () => ({
  isContentLoaded: false,
  heroContent: {},
  informationContent: {},
  leadershipContent: {},
  footerContent: {},
});
